import React from 'react'
import { observer } from 'mobx-react'
import { Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap'
import * as defaultConst from '../constants/default_constants'
import EtlNavbar from './page/etl_navbar'
import UploadInfo from './uploadinfo'

const UserInfo = ({ store }) => {
  const loggedUserData = store.loggedUser
  if (!loggedUserData) {
    return <span>{/* store.__('anonymous') */}</span>
  }

  let c = 1 // eventKey counter
  const confirmText = store.__('Start materializing data for web publishing?')
  const feedbackTxt = store.__('Add feedback or issue to the FilmCargo board in ClickUp.')
  const feedbackURL = 'https://app.clickup.com/4631734/v/b/li/50744290'
  const isPublishing = store.router.publish && store.router.publish.loading
  const designListNew = [
    'darkly',
    'darkly-yellow'
  ]
  const designList = [
    'cerulean',
    'dark-slate',
    'darkly',
    'darkly-yellow',
    'modern',
    'original',
    'sandstone',
    'simplex',
    'simplex-snow',
    // 'spacelab',
    'united',
    'yeti'
  ]

  function handleLogout (e) {
    e.stopPropagation()
    store.logout()
  }

  function handlePublishing (value) {
    store.router.publish.loading = value
    store.callURL('post', '/service/callproc/proc_materialize_FP_data_for_API').then(() => {
      store.addMessage(store.__('Publishing done!'), 'success', 3000)
    }).catch(store.onRequesterError.bind(store)).then(() => {
      store.router.publish.loading = !value
    })
  }

  function handleSwitchCss (newcss) {
    store.switchCss(newcss)
  }

  return (
    <Nav pullRight>
      <EtlNavbar eventKey={c++} store={store} runnerNavStatus={store.runnerNavStatus} />
      <UploadInfo eventKey={c++} store={store} />
      {store.hasRight(defaultConst.ENTNAMES.PUBLISH) &&
          <NavItem eventKey={c++} disabled={isPublishing} className='hide-menu-title' title={store.__('Publish')}
            onClick={() => window.confirm(confirmText) && handlePublishing(true)}>
            {isPublishing
              ? <i className='glyphicon glyphicon-refresh glyphicon-refresh-animate text-success' />
              : <i className='glyphicon glyphicon-cloud-upload' />}
            {isPublishing
              ? <span className='text-success'>{store.__('Publishing...')}</span>
              : <span>{store.__('Publish')}</span>
            }
          </NavItem>}
      <NavItem className='hide-menu-title' eventKey={c++} title={store.__(feedbackTxt)} href={feedbackURL} target='_blank' rel='noreferrer'>
        <i className='glyphicon glyphicon-bullhorn' /> <span>{store.__('Feedback')}</span>
      </NavItem>
      <NavDropdown eventKey={c++} className='hide-menu-title' id='user-nav-dropdown'
        title={<React.Fragment><i className='glyphicon glyphicon-user' /><span>{store.__('User')}</span></React.Fragment>}>
        {loggedUserData.nickname && <MenuItem header>
          <strong className='user-name'>{loggedUserData.nickname}</strong>
        </MenuItem>}
        {loggedUserData.email && <MenuItem header>{loggedUserData.email}</MenuItem>}
        {loggedUserData.picture && <MenuItem header><img src={loggedUserData.picture} style={{ borderRadius: '50%' }} /></MenuItem>}
        <MenuItem divider />
        <MenuItem eventKey={c++} href={'/?ts' + (Math.round(+new Date() / 1000))}>
          <i className='glyphicon glyphicon-home' />{store.__('Homepage')}
        </MenuItem>
        <MenuItem eventKey={c++} onClick={() => store.router.goTo(store.views.changelog, {}, store, {})}>
          <i className='glyphicon glyphicon-list' />{store.__('Changelog')}
        </MenuItem>
        <MenuItem eventKey={c++} title={store.__(feedbackTxt)} href={feedbackURL} target='_blank' rel='noreferrer'>
          <i className='glyphicon glyphicon-bullhorn' />{store.__('Add feedback/issue')}
        </MenuItem>
        <NavDropdown eventKey={c++} pullRight id='nav-dropdown-templates'
          title={<React.Fragment><i className='glyphicon glyphicon-picture' /> {store.__('Templates')}</React.Fragment>}>
          {designList.map((item, idx) => (
            <MenuItem key={idx} className={(item === store.userCss) && 'active'} onClick={() => handleSwitchCss(item)}>
              {item} &nbsp;
              {designListNew.indexOf(item) !== -1 && <span className='label label-default'>{store.__('new')}</span>}
            </MenuItem>
          ))}
        </NavDropdown>
        <MenuItem divider />
        <MenuItem eventKey={c++} onClick={handleLogout} style={{ marginBottom: '0.8em' }}>
          <i className='glyphicon glyphicon-log-out' />{store.__('Logout')}
        </MenuItem>
      </NavDropdown>
    </Nav>
  )
}

export default observer(UserInfo)
